/** Business settings (docs/specs/tenant-settings.md). */
export const settings = {
    title: "Business settings",
    description: "Your business profile, invoices, region and sales rules.",
    readOnly: "You can view these settings. Only an Owner or Admin can change them.",
    sections: {
        profile: "Business profile",
        invoices: "Invoices and receipts",
        region: "Region",
        sales: "Sales rules",
    },
    name: "Business name",
    logo: "Logo",
    noLogo: "No logo yet",
    uploadLogo: "Upload logo",
    removeLogo: "Remove logo",
    uploading: "Uploading…",
    logoFailed: "The logo could not be used. Upload a JPEG, PNG or WebP image.",
    address: "Address",
    phone: "Phone",
    phoneHint: "Bangladeshi mobile number, e.g. 01712-345678",
    bin: "BIN (VAT registration)",
    binHint: "13 digits",
    invoiceFooter: "Invoice footer",
    customerLocale: "Language for customers",
    customerLocaleHint: "Used on receipts, invoices and SMS to your customers.",
    timezone: "Time zone",
    taxMode: "Prices and VAT",
    taxModes: { inclusive: "Prices include VAT", exclusive: "VAT is added to prices" },
    discountLimit: "Discount limit without approval (%)",
    discountLimitHint: "Staff with a limited discount permission need a manager's approval above this.",
    refundLimit: "Refund limit without approval (৳)",
    refundLimitHint: "Staff with a limited refund permission need a manager's approval above this.",
    saved: "Settings saved.",
    conflict: "Someone else changed these settings. The latest values are shown; make your change again.",
};
//# sourceMappingURL=settings.js.map